import IntCarousel from "./IntCarousel";
import InteriorImg from "./InteriorImg";
import interiorImage from "./interior1.jpg"; // Adjust path as needed
import "./Interior.css";

export default function Interior() {
  return (
    <div
      className="parallax-container"
      style={{ backgroundImage: `url(${interiorImage})` }}
    >
      <div className="content">
        <InteriorImg />
        <IntCarousel />
      </div>
    </div>
  );
}
